// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__KRifj","list":"PatternAutocomplete_list__1u89w"};